import { TaskRoute } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";
import {
    ProgressStateKeys,
    selectCheckoutDetailsByOrderId,
    selectTaskPayload,
} from "@/store/slices/progress";

export const useTaskPayloadSelector = <R extends TaskRoute & ProgressStateKeys>(
    taskRoute: R,
    taskId: string,
) => useAppSelector((state) => selectTaskPayload(state, { taskRoute, taskId }));

export const useCheckoutDetailsSelector = (orderId: string) =>
    useAppSelector((state) => selectCheckoutDetailsByOrderId(state, orderId));
